/* eslint-disable no-use-before-define */

import React from 'react';
import _ from 'lodash';
import { Checkbox, Icon, Popup } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import {
  getTargetingSentencelines,
  getAdMetrics,
  getFullAd,
  getEventSourceGroup,
  getAdCreative,
  getInstagramStoryIframe
} from '../fbApi/Ad';
import { getAdGeneratePreview, getAdPreview } from '../fbApi/AdPreview';
import { getCanvas, getCanvasElement } from '../fbApi/Canvas';
import getLead from '../fbApi/Lead';
import { getAdLineageQcNotes } from './ad.lineage';
import { getProductSet } from '../fbApi/ProductSet';
import { getCanvasFooter } from '../fbApi/Footer';
import { getCanvasButton } from '../fbApi/Button';
import { getCanvasPhoto } from '../fbApi/Image';

const getEncodedCleanText = (text) =>
  encodeURIComponent(text.replace(/[\r\n]+/g, ' '));
export const getPreviews = async (ad, token, isCanvas, isCollection) => {
  const preview = {};
  const desktopResult = await getAdPreview(
    ad.id,
    'DESKTOP_FEED_STANDARD',
    token
  );
  const mobileResult = await getAdPreview(ad.id, 'MOBILE_FEED_STANDARD', token);
  preview.desktop = desktopResult.data;
  preview.mobile = mobileResult.data;

  let deskUrl = preview.desktop[0].body;
  deskUrl = deskUrl.substring(deskUrl.indexOf('src') + 5);
  deskUrl = deskUrl.substring(0, deskUrl.indexOf('"'));
  let mobUrl = preview.mobile[0].body;
  mobUrl = mobUrl.substring(mobUrl.indexOf('src') + 5);
  mobUrl = mobUrl.substring(0, mobUrl.indexOf('"'));
  preview.mobile = `<iframe src="${mobUrl}" width="335" height="620" scrolling="no" style="border: none;"></iframe>`;
  preview.desktop = `<iframe src="${deskUrl}" width="720" height="690" scrolling="yes" style="border: none;"></iframe>`;

  if (isCollection) {
    preview.desktop =
      '<span style="height: 720px; width: 720px;">This ad type is mobile-only, so no desktop preview exists.</span>';
  }

  if (isCanvas) {
    preview.desktop =
      '<span style="height: 720px; width: 720px;">No Desktop I-frame exists for this ad type</span>';
  }

  if (
    ad.name.split('360').length > 1 &&
    ad.campaign.objective === 'VIDEO_VIEWS'
  ) {
    preview.mobile = preview.mobile.replace('height="720"', 'height="300"');
    preview.mobile +=
      '<div class="ui segment floated left inline text" style="margin-left: 10px; width:320px"><p>Due to differences in hardware, mobile 360 video cannot be previewed via desktop.</p><p>Please use the desktop preview window to view your content.</p></div>';
  }

  preview.mobile = preview.mobile.replace('scrolling="yes"', 'scrolling="no"');
  return preview;
};

const getOrder = (adName) => {
  if (adName.indexOf('Canvas') >= 0) {
    return 0;
  }
  if (adName.indexOf('Carousel') >= 0) {
    return 1;
  }
  if (adName.indexOf('Collection') >= 0 || adName.indexOf('Cinemagraph') >= 0) {
    return 3;
  }
  if (adName.indexOf('Corporate') >= 0) {
    return 4;
  }
  return 5;
};

const getCleanLink = (link) => {
  if (link && link.indexOf('?') !== -1) {
    return link.substring(0, link.indexOf('?'));
  }
  return link;
};

const getDestinationUrl = async (obj, token) => {
  try {
    {
      if (!obj || !obj.name) {
        return '';
      }
      const lastElement = obj.body_elements[obj.body_elements.length - 1];

      if (lastElement.element_type === 'FOOTER') {
        const footer = await getCanvasFooter(lastElement.id, token);
        const button = footer.child_elements.find(
          (o) => o.element_type === 'BUTTON'
        );

        if (button) {
          const canvasButton = await getCanvasButton(button.id, token);
          if (
            canvasButton &&
            canvasButton.action &&
            canvasButton.action.type === 'OPEN_URL'
          ) {
            return canvasButton.action.url;
          }
        }
      } else if (lastElement.element_type === 'PHOTO') {
        const canvasPhoto = await getCanvasPhoto(lastElement.id, token);
        if (
          canvasPhoto &&
          canvasPhoto.action &&
          canvasPhoto.action.type === 'OPEN_URL'
        ) {
          return canvasPhoto.action.url;
        }
      } else {
        return 'Error: Unsupported Footer';
      }
      return '';
    }
  } catch (error) {
    console.log('It seems an ad was not built correctly: ', obj);
    console.log('Error in ad.common getDestinationUrl: ', error);
    toast.error(`Something went wrong with an ad called\n ${obj.name}`, {
      position: 'bottom-center',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    return 'Error: Unsupported body_elements';
  }
};

const generatePreviewCreative = (creative, isCarousel) => {
  const creativeObject = creative.object_story_spec;
  let previewObj = {};
  if (creativeObject) {
    if (creativeObject.link_data) {
      if (isCarousel) {
        previewObj = {
          ...creativeObject,
          link_data: {
            ...creativeObject.link_data,
            link: getCleanLink(creativeObject.link_data.link),
            message: getEncodedCleanText(creativeObject.link_data.message)
          }
        };
      } else {
        previewObj = {
          ...creativeObject,
          link_data: {
            ...creativeObject.link_data,
            name: getEncodedCleanText(creativeObject.link_data.name),
            message: getEncodedCleanText(creativeObject.link_data.message),
            description: getEncodedCleanText(
              creativeObject.link_data.description
            ),
            link: getCleanLink(creativeObject.link_data.link),
            call_to_action: {
              ...creativeObject.link_data.call_to_action,
              value: {
                ...creativeObject.link_data.call_to_action.value,
                link:
                  creativeObject.link_data.call_to_action.value &&
                  creativeObject.link_data.call_to_action.value.link
                    ? getCleanLink(
                        creativeObject.link_data.call_to_action.value.link
                      )
                    : undefined
              }
            }
          }
        };
        if (previewObj.link_data.image_url) {
          previewObj.link_data.image_url = getEncodedCleanText(
            previewObj.link_data.image_url
          );
        }
        if (previewObj.link_data.image_hash && previewObj.link_data.image_url) {
          previewObj.link_data = _.omit(previewObj.link_data, ['image_hash']);
        }
        if (previewObj.link_data.image_hash && previewObj.link_data.picture) {
          previewObj.link_data = _.omit(previewObj.link_data, ['image_hash']);
        }
      }
      if (
        creativeObject.link_data &&
        creativeObject.link_data.child_attachments
      ) {
        previewObj.link_data.child_attachments = creativeObject.link_data.child_attachments.map(
          (l) => {
            const newL = {
              ...(l.picture && l.image_hash ? _.omit(l, ['image_hash']) : l),
              picture: l.picture,
              name: l.name,
              link: getCleanLink(l.link)
            };
            if (
              newL.call_to_action &&
              newL.call_to_action.value &&
              newL.call_to_action.value.link
            ) {
              newL.call_to_action.value.link = getCleanLink(
                l.call_to_action.value.link
              );
            }
            if (newL.picture) {
              newL.picture = getEncodedCleanText(newL.picture);
            }
            return newL;
          }
        );
      }
      if (previewObj.link_data.picture) {
        previewObj.link_data.picture = getEncodedCleanText(
          previewObj.link_data.picture
        );
      }
      if (previewObj.link_data.image_url) {
        previewObj.link_data.image_url = getEncodedCleanText(
          previewObj.link_data.image_url
        );
      }
    } else if (creativeObject.template_data) {
      previewObj = {
        ...creativeObject,
        template_data: {
          ...creativeObject.template_data,
          message: getEncodedCleanText(creativeObject.template_data.message),
          description: getEncodedCleanText(
            creativeObject.template_data.description
          ),
          link: getCleanLink(creativeObject.template_data.link),
          call_to_action: {
            ...creativeObject.template_data.call_to_action,
            value: {
              ...creativeObject.template_data.call_to_action.value,
              link:
                creativeObject.template_data.call_to_action.value &&
                creativeObject.template_data.call_to_action.value.link
                  ? getCleanLink(
                      creativeObject.template_data.call_to_action.value.link
                    )
                  : undefined
            }
          }
        }
      };
      if (
        creativeObject.template_data &&
        creativeObject.template_data.child_attachments
      ) {
        previewObj.template_data.child_attachments = creativeObject.template_data.child_attachments.map(
          (l) => ({
            ...(l.picture && l.image_hash ? _.omit(l, ['picture']) : l),
            name: l.name,
            link: getCleanLink(l.link)
          })
        );
      }
      if (
        previewObj.template_data.image_hash &&
        previewObj.template_data.image_url
      ) {
        previewObj.template_data = _.omit(previewObj.template_data, [
          'image_hash'
        ]);
      }
      if (
        previewObj.template_data.image_hash &&
        previewObj.template_data.picture
      ) {
        previewObj.template_data = _.omit(previewObj.template_data, [
          'image_hash'
        ]);
      }
      if (previewObj.template_data.image_url) {
        previewObj.template_data.image_url = getEncodedCleanText(
          previewObj.template_data.image_url
        );
      }
    } else if (creativeObject.video_data) {
      previewObj = {
        ...creativeObject,
        video_data: {
          ...creativeObject.video_data,
          title: getEncodedCleanText(creativeObject.video_data.title),
          message: getEncodedCleanText(creativeObject.video_data.message),
          link_description: getEncodedCleanText(
            creativeObject.video_data.link_description
          ),
          call_to_action: {
            ...creativeObject.video_data.call_to_action,
            value: {
              ...creativeObject.video_data.call_to_action.value,
              link:
                creativeObject.video_data.call_to_action.value &&
                creativeObject.video_data.call_to_action.value.link
                  ? getCleanLink(
                      creativeObject.video_data.call_to_action.value.link
                    )
                  : undefined
            }
          }
        }
      };
      if (
        creativeObject.video_data &&
        creativeObject.video_data.child_attachments
      ) {
        previewObj.video_data.child_attachments = creativeObject.video_data.child_attachments.map(
          (l) => ({
            ...(l.picture && l.image_hash ? _.omit(l, ['picture']) : l),
            name: l.name,
            link: l.link.substring(0, l.link.indexOf('?'))
          })
        );
      }
      if (previewObj.video_data.image_hash && previewObj.video_data.image_url) {
        previewObj.video_data = _.omit(previewObj.video_data, ['image_hash']);
      }
      if (previewObj.video_data.image_hash && previewObj.video_data.picture) {
        previewObj.video_data = _.omit(previewObj.video_data, ['image_hash']);
      }
      if (previewObj.video_data.image_url) {
        previewObj.video_data.image_url = getEncodedCleanText(
          previewObj.video_data.image_url
        );
      }
    }
  }
  return { object_story_spec: previewObj };
};

const getFacebookInfo = (ad, targetingSentenceLines) => {
  const creativeObject = ad.creative.object_story_spec;
  const adCopyData = {
    ad_title: '',
    ad_body: '',
    ad_link: '',
    creativeId: ad.creative.id,
    description: '',
    callToActionType: '',
    linkCaption: '',
    audience: null,
    audienceArray: null
  };

  if (targetingSentenceLines !== null) {
    adCopyData.audience = getAudienceLines(targetingSentenceLines);
    adCopyData.audienceArray = targetingSentenceLines;
  }

  if (creativeObject) {
    if (creativeObject.link_data) {
      adCopyData.ad_body = creativeObject.link_data.message;
      adCopyData.ad_link = creativeObject.link_data.link;
      adCopyData.callToActionText = creativeObject.link_data.call_to_action
        ? creativeObject.link_data.call_to_action.type
        : '';
      if (
        creativeObject.link_data &&
        creativeObject.link_data.child_attachments
      ) {
        const carouselTitles = creativeObject.link_data.child_attachments.map(
          (l) => l.name
        );
        const carouselLinks = creativeObject.link_data.child_attachments.map(
          (l) => l.description
        );
        adCopyData.ad_title = carouselTitles;
        adCopyData.description = carouselLinks;
      } else {
        adCopyData.description = creativeObject.link_data.description;
        adCopyData.ad_title = creativeObject.link_data.name;
      }
      if (
        creativeObject.link_data.call_to_action &&
        creativeObject.link_data.call_to_action.value &&
        creativeObject.link_data.call_to_action.value.link
      ) {
        adCopyData.linkCaption =
          creativeObject.link_data.call_to_action.value.link_caption;
      }
    } else if (creativeObject.template_data) {
      adCopyData.ad_title = creativeObject.template_data.name;
      adCopyData.ad_body = creativeObject.template_data.message;
      adCopyData.ad_link = creativeObject.template_data.link;
      adCopyData.description = creativeObject.template_data.description;
      adCopyData.callToActionText = creativeObject.template_data.call_to_action
        ? creativeObject.template_data.call_to_action.type
        : '';
      adCopyData.linkCaption = creativeObject.template_data.call_to_action
        ? creativeObject.template_data.call_to_action.link_caption
        : creativeObject.template_data.caption;
    } else if (creativeObject.video_data) {
      adCopyData.ad_title = creativeObject.video_data.title;
      adCopyData.ad_body = creativeObject.video_data.message;
      adCopyData.description = creativeObject.video_data.link_description;
      adCopyData.callToActionText = creativeObject.video_data.call_to_action
        ? creativeObject.video_data.call_to_action.type
        : '';
      if (
        creativeObject.video_data.call_to_action &&
        creativeObject.video_data.call_to_action.value &&
        creativeObject.video_data.call_to_action.value.link
      ) {
        adCopyData.ad_link =
          creativeObject.video_data.call_to_action.value.link;
        adCopyData.linkCaption =
          creativeObject.video_data.call_to_action.value.link_caption;
      }
    }
    adCopyData.callToActionType = adCopyData.callToActionText;
  }
  return adCopyData;
};

const getAudienceLines = (targetingSentenceLines) => {
  const audience = targetingSentenceLines.targetingsentencelines.targetingsentencelines.map(
    (target) => `${target.content} ${target.children[0]}`
  );

  return audience.join('\n');
};

export const getEventSourceGroupName = async (ads) => {
  const esgNameObjects = await Promise.all(
    // eslint-disable-next-line consistent-return
    ads.map(async (ad) => {
      try {
        if (ad) {
          if (ad.facebookInfo.audienceArray) {
            const audience = ad.facebookInfo.audienceArray;
            const elementToScan = audience.targetingsentencelines.targetingsentencelines.find(
              (element) => {
                return element.content.includes('Dynamic');
              }
            );
            let foundEsgName = '';
            if (elementToScan) {
              const esgId = elementToScan.children[0].match(
                '^(Vehicle events from event source)([0-9 ]*)'
              )
                ? elementToScan.children[0].match(
                    '^(Vehicle events from event source)([0-9 ]*)'
                  )[2]
                : null;
              if (esgId && esgId.trim() !== '') {
                const esgData = await getEventSourceGroup(esgId);
                foundEsgName = esgData.name;
                const id = ad.id || ad.ad_id;
                return { ad_id: id, esgName: foundEsgName };
              }
            }
          }
        }
      } catch (error) {
        console.log('getEventSourceGroupName()', error);
      }
    })
  );
  return esgNameObjects.filter((esgObject) => esgObject);
};

export const generateNewPreviewFromCreative = async (ad, token) => {
  const { creative, isCarousel, account_id: accountId } = ad;
  const generatePreviewObj = generatePreviewCreative(creative, isCarousel);
  const preview = {};
  const desktopResult = await getAdGeneratePreview(
    accountId,
    generatePreviewObj,
    'DESKTOP_FEED_STANDARD',
    token
  );
  const mobileResult = await getAdGeneratePreview(
    accountId,
    generatePreviewObj,
    'MOBILE_FEED_STANDARD',
    token
  );

  const { data: desktopData } = desktopResult;
  const { data: mobileData } = mobileResult;

  let deskUrl;
  let mobUrl;

  if (desktopData && desktopData.length > 0) {
    const { body } = desktopData[0];
    deskUrl = body;
    deskUrl = deskUrl.substring(deskUrl.indexOf('src') + 5);
    deskUrl = deskUrl.substring(0, deskUrl.indexOf('"'));
    preview.desktop = `<iframe src="${deskUrl}" width="720" height="690" scrolling="yes" style="border: none;"></iframe>`;
  } else {
    preview.desktop = null;
  }

  if (mobileData && mobileData.length > 0) {
    const { body } = mobileData[0];
    mobUrl = body;
    mobUrl = mobUrl.substring(mobUrl.indexOf('src') + 5);
    mobUrl = mobUrl.substring(0, mobUrl.indexOf('"'));
    preview.mobile = `<iframe src="${mobUrl}" width="335" height="620" scrolling="no" style="border: none;"></iframe>`;
  } else {
    preview.mobile = null;
  }

  return preview;
};

export const sortAdsByFormatV2 = (firstAds, secondAds) => {
  const commonAdsFirst = [];
  const commonAdsSecond = [];
  const differentAdsFirst = [];
  const differentAdsSecond = [];
  firstAds.forEach((ad) => {
    const byNameFilter = secondAds.find((item) => item.ad_name === ad.ad_name);
    const byLineage = secondAds.find(
      (item) =>
        item.lineageInfo !== null &&
        ad.lineageInfo !== null &&
        item.lineageInfo.parentAdId === ad.lineageInfo.parentAdId
    );
    let secondAd;
    if (byNameFilter) {
      secondAd = byNameFilter;
    } else if (byLineage) {
      secondAd = byLineage;
    }
    if (secondAd) {
      commonAdsFirst.push(ad);
      commonAdsSecond.push(secondAd);
    } else {
      differentAdsFirst.push(ad);
    }
  });

  secondAds.forEach((ad) => {
    const addedAd = commonAdsSecond.find((item) => item.ad_name === ad.ad_name);
    if (!addedAd) {
      differentAdsSecond.push(ad);
    }
  });

  return {
    sortedAdsFirst: commonAdsFirst,
    sortedAdsSecond: commonAdsSecond,
    differentAdsFirst,
    differentAdsSecond
  };
};

export const sortAdsByFormat = (firstAds, secondAds) => {
  const commonAdsFirst = [];
  const commonAdsSecond = [];
  const differentAdsFirst = [];
  const differentAdsSecond = [];
  firstAds.forEach((ad) => {
    const secondAd = secondAds.find((item) => {
      if (item.lineageInfo !== null && ad.lineageInfo !== null) {
        return item.lineageInfo.parentAdId === ad.lineageInfo.parentAdId;
      }
      return item.ad_name === ad.ad_name;
    });
    if (secondAd) {
      commonAdsFirst.push(ad);
      commonAdsSecond.push(secondAd);
    } else {
      differentAdsFirst.push(ad);
    }
  });

  secondAds.forEach((ad) => {
    const addedAd = commonAdsSecond.find((item) => item.ad_name === ad.ad_name);
    if (!addedAd) {
      differentAdsSecond.push(ad);
    }
  });

  const sortedAdsFirst = commonAdsFirst.concat(differentAdsFirst);
  const sortedAdsSecond = commonAdsSecond.concat(differentAdsSecond);

  return {
    sortedAdsFirst,
    sortedAdsSecond
  };
};

export const getRawAdName = (adName) => {
  if (!adName) return '';
  if (adName.indexOf('_') === -1) {
    return adName;
  }
  const splitName = adName.split('_');

  if (!isNaN(splitName[0])) {
    splitName.splice(0, 1);
  }

  splitName.splice(0, 1);
  return splitName.join(' ');
};

export const buildAdPreviewObjectCompare = async (ad, selection, token) => {
  const targetingSentenceLines =
    selection.trim() === ''
      ? null
      : await getTargetingSentencelines(ad.id, token);
  const adMetrics =
    selection.trim() === '' ? null : await getAdMetrics(ad.id, token);
  const adcreatives = ad.adcreatives;
  const link = ad.creative.object_story_spec;
  let ll = [];
  let l = null;
  let canvasName = {};
  let leadFormName = {};
  let isCarousel = false;
  try {
    if (link) {
      if (link.link_data && link.link_data.child_attachments) {
        isCarousel = true;
        link.link_data.child_attachments.forEach((li) => ll.push(li.link));
      }

      if (
        link.video_data &&
        link.video_data.call_to_action &&
        link.video_data.call_to_action &&
        link.video_data.call_to_action.value &&
        link.video_data.call_to_action.value.link
      ) {
        l = link.video_data.call_to_action.value.link;
        ll.push(l);
      }

      if (link.call_to_action && link.call_to_action.link) {
        l = link.call_to_action.link;
        ll.push(l);
      }

      if (link.link_data && link.link_data.link) {
        l = link.link_data.link;
        ll.push(l);
      }

      if (link.template_data && link.template_data.link) {
        l = link.template_data.link;
        ll.push(l);
      }

      if (
        link.link_data &&
        link.link_data.call_to_action &&
        link.link_data.call_to_action.value &&
        link.link_data.call_to_action.value.lead_gen_form_id
      ) {
        try {
          leadFormName = await getLead(
            link.link_data.call_to_action.value.lead_gen_form_id,
            token
          );
        } catch (error) {
          leadFormName = 'You need permission to access this Lead Form';
        }
        ll = [];
      }
    }
  } catch (e) {
    console.log('urls error', e);
    ll = [];
  }

  const url = window.location.href;

  let isCanvas = false;
  if (!url.includes('organicSimplifier')) {
    await Promise.all(
      ll.map(async (li) => {
        if (li) {
          if (li.split('canvas_doc').length > 1) {
            isCanvas = true;
            await getCanvas(_.last(li.split('/')), token).then((data) => {
              canvasName = data;
              return Promise.resolve(data);
            });
          } else {
            return Promise.resolve(null);
          }
        } else {
          return Promise.resolve(null);
        }
        return null;
      })
    );
  }

  let destinationUrl = '';
  if (isCanvas) {
    ll = [];
    destinationUrl = await getDestinationUrl(canvasName, token);
  }
  let preview = {};
  if (selection.trim() !== '') {
    preview = await getPreviews(
      ad,
      token,
      isCanvas,
      ad.name.split('Collection').length > 1
    );
  } else {
    preview.desktop_iframe_url = null;
    preview.mobile_iframe_url = null;
  }

  const startDateSplit = ad.adset.start_time.split('-');
  const startDate = new Date(
    startDateSplit[0],
    (Number(startDateSplit[1]) - 1).toString(),
    startDateSplit[2].slice(0, 2)
  );

  let endDate = null;
  if (ad.adset.end_time) {
    const endDateSplit = ad.adset.end_time.split('-');
    endDate = new Date(
      endDateSplit[0],
      (Number(endDateSplit[1]) - 1).toString(),
      endDateSplit[2].slice(0, 2)
    );
  }

  const st = startDate.toDateString();
  const et = endDate ? endDate.toDateString() : null;

  const isCollection = ad.name.split('Collection').length > 1;
  const isCarouselFromAdName = ad.name.split('Carousel').length > 1;

  let productSetId =
    ad.adset.promoted_object && ad.adset.promoted_object.product_set_id
      ? ad.adset.promoted_object.product_set_id
      : null;

  if (isCollection) {
    if (canvasName && canvasName.body_elements) {
      const elementGroup = canvasName.body_elements.find(
        (elem) => elem.element_type === 'ELEMENT_GROUP'
      );
      if (elementGroup) {
        const canvasElement = await getCanvasElement(elementGroup.id, token);
        productSetId = canvasElement.product_set_id;
      }
    }
  }

  let productSet = null;
  if (productSetId) {
    productSet = await getProductSet(productSetId, token);
    if (productSet.error || !productSet) {
      const { id, name } = ad;
      handleProductSetError(id, name, productSetId);
    }
  }

  const adData = ad.adData ? ad.adData : await getAdLineageQcNotes(ad.id);

  const adLineage = adData.adLineage;
  const adNotes = adData.adNotes;
  const adQc = adData.adQc;
  const adReport = adData.adReport;
  const adCopyData = getFacebookInfo(ad, targetingSentenceLines);
  const previewObject = {
    start_time: st,
    end_time: et,
    destination_url: ll,
    ad_status: ad.effective_status,
    ad_review_feedback: ad.ad_review_feedback,
    lead_form_name: leadFormName,
    canvas_name: canvasName,
    productSetVehicles: productSet ? productSet.vehicles : '',
    productSetName: productSet ? productSet.name : '',
    productCatalogName:
      productSet && productSet.product_catalog
        ? productSet.product_catalog.name
        : '',
    destinationUrl,
    adset_name: ad.adset.name,
    promoted_object: ad.adset.promoted_object,
    ad_name: getRawAdName(ad.name),
    ad_original_name: ad.name,
    ad_title: adCopyData.ad_title,
    ad_body: adCopyData.ad_body,
    ad_link: adCopyData.ad_link,
    ad_id: ad.id,
    campaignObjective: ad.campaign.objective,
    url_tags: adcreatives.data.length >= 0 ? adcreatives.data[0].url_tags : '',
    desktop_iframe_url: preview.desktop,
    mobile_iframe_url: preview.mobile,
    selection,
    adObjective: ad.creative.object_story_spec,
    lineageInfo: adLineage,
    facebookInfo: adCopyData,
    metrics: adMetrics && adMetrics.data ? adMetrics.data[0] : {},
    account_id: ad.account_id,
    adNotes,
    adQc,
    adReport,
    isCarousel,
    isCanvas,
    order: getOrder(ad.name, adData),
    lineageOrder: adData.adLineage && adData.adLineage.adId ? 1 : 0
  };

  // this if block is needed for checking if an ad is a dynamic carousel ad
  // Dynamic carousels typically have isCarousel = false,
  // but they will have 'Carousel' in the name plus a valid productSetId
  if (isCarouselFromAdName && !isCarousel && productSetId) {
    const { facebookInfo } = previewObject;
    const { creativeId } = facebookInfo;
    const checkAdProductSetResult = await checkAdProductSet(creativeId, token);
    productSetId = checkAdProductSetResult;
    productSet = await getProductSet(productSetId, token);
    if (!productSet.error) {
      const {
        name: productSetName,
        product_catalog: productCatalog,
        vehicles: productVehicles
      } = productSet;
      previewObject.productSetName = productSetName;
      previewObject.productCatalogName = productCatalog
        ? productCatalog.name
        : '';
      previewObject.productSetVehicles = productVehicles || [];
    } else {
      const { ad_id: adId, ad_original_name: adOriginalName } = previewObject;
      handleProductSetError(adId, adOriginalName, productSetId);
    }
  }

  return previewObject;
};

const handleProductSetError = (adId, adName, productSetId) => {
  const diagnosticInfo = `Ad ID: ${adId}, Ad Name: ${adName}, Product Set ID: ${productSetId}`;
  console.log(
    'Something went wrong with getting the product set info: ',
    diagnosticInfo
  );
};

export const getErrorReportAd = async (adId, token) => {
  const ad = await getFullAd(adId, token);
  const isCollection = ad.name.split('Collection').length > 1;
  const link = ad.creative.object_story_spec;
  let ll = [];
  let l = null;
  try {
    if (link) {
      if (link.link_data && link.link_data.child_attachments) {
        link.link_data.child_attachments.forEach((li) => ll.push(li.link));
      }

      if (
        link.video_data &&
        link.video_data.call_to_action &&
        link.video_data.call_to_action &&
        link.video_data.call_to_action.value &&
        link.video_data.call_to_action.value.link
      ) {
        l = link.video_data.call_to_action.value.link;
        ll.push(l);
      }

      if (link.call_to_action && link.call_to_action.link) {
        l = link.call_to_action.link;
        ll.push(l);
      }

      if (link.link_data && link.link_data.link) {
        l = link.link_data.link;
        ll.push(l);
      }

      if (link.template_data && link.template_data.link) {
        l = link.template_data.link;
        ll.push(l);
      }

      if (
        link.link_data &&
        link.link_data.call_to_action &&
        link.link_data.call_to_action.value &&
        link.link_data.call_to_action.value.lead_gen_form_id
      ) {
        ll = [];
      }
    }
  } catch (e) {
    console.log('urls error', e);
    ll = [];
  }

  let isCanvas = false;
  ll.forEach(async () => {
    if (l !== null) {
      if (l.split('canvas_doc').length > 1) {
        isCanvas = true;
      }
    }
  });
  const preview = await getPreviews(ad, token, isCanvas, isCollection);

  return {
    ad,
    preview,
    isCanvas,
    isCollection,
    adFriendlyName: getRawAdName(ad.name)
  };
};

export const renderErrorReport = (preview) => {
  if (preview.adReport) {
    return (
      <Icon
        style={{ verticalAlign: 'unset' }}
        name="bug"
        color="black"
        size="large"
      />
    );
  }
  return null;
};

export const renderHoldAd = (preview) => {
  if (preview.adQc && preview.adQc.on_hold) {
    return (
      <Icon
        style={{ verticalAlign: 'unset' }}
        name="warning sign"
        color="black"
        size="large"
      />
    );
  }
  return null;
};

export const renderNoteWarning = (preview) => {
  const note = preview.adNotes.find((n) => n.note_qc);
  if (note) {
    return (
      <Icon style={{ verticalAlign: 'unset' }} name="comments" size="large" />
    );
  }
  return null;
};

export const renderPopupQCOrCheckbox = (preview, qcNumber) => {
  let iconName = 'square outline';
  let qcColor = 'grey';
  if (preview.adQc) {
    if (preview.adQc[qcNumber] !== 'false' && preview.adQc[qcNumber] !== null) {
      const qcName =
        preview.adQc && preview.adQc[`${qcNumber}Fullname`] === ''
          ? preview.adQc[`${qcNumber}Username`]
          : preview.adQc[`${qcNumber}Fullname`];

      switch (preview.adQc[qcNumber]) {
        case 'true':
          iconName = 'check square';
          qcColor = 'green';
          break;
        case 'inter':
          iconName = 'minus square';
          qcColor = 'yellow';
          break;
        default:
          iconName = 'square outline';
          qcColor = 'grey';
          break;
      }

      return (
        <Popup
          wide="very"
          position="top center"
          trigger={
            <Icon
              className="qc-checkbox-icon"
              name={iconName}
              size="large"
              color={qcColor}
            />
          }
          content={
            <small>
              {preview.adQc[qcNumber] === 'inter'
                ? `Hold Released - ${qcName}`
                : qcName}
            </small>
          }
        />
      );
    }
  }
  return (
    <Icon
      name={iconName}
      className="qc-checkbox-icon"
      size="large"
      color={qcColor}
    />
  );
};

export const multiRenderPopupQCOrCheckbox = (
  adInfo,
  preview,
  qcNumber,
  inMultiQc
) => {
  if (inMultiQc) {
    const { adQc } = adInfo ? adInfo.adData : adQc;
    // eslint-disable-next-line no-param-reassign
    preview.adQc = adQc;
  }
  if (preview.adQc) {
    const classQC =
      preview.adQc[qcNumber] === 'inter' ? 'qc-checkbox-yellow' : 'qc-checkbox';

    if (preview.adQc[qcNumber] !== 'false' && preview.adQc[qcNumber] !== null) {
      const qcName =
        preview.adQc && preview.adQc[`${qcNumber}Fullname`] === ''
          ? preview.adQc[`${qcNumber}Username`]
          : preview.adQc[`${qcNumber}Fullname`];
      return (
        <Popup
          wide="very"
          trigger={
            <Checkbox
              disabled
              className={classQC}
              checked={
                preview.adQc[qcNumber] === 'true' ||
                preview.adQc[qcNumber] === 'inter'
              }
            />
          }
          content={
            <small>
              {preview.adQc[qcNumber] === 'inter'
                ? `Hold Released - ${qcName}`
                : qcName}
            </small>
          }
        />
      );
    }
  }
  return <Checkbox disabled className="qc-checkbox" />;
};

export const getColorRow = (preview) => {
  if (!preview) {
    return null;
  }

  if (preview.adQc && preview.adQc.on_hold) {
    return '#db2828';
  }

  const note = preview.adNotes ? preview.adNotes.find((n) => n.note_qc) : null;
  if (note) {
    return '#fbbd08';
  }
  return null;
};

export const renderDestinationUrls = (urls) => {
  if (urls.length > 0) {
    return (
      <div>
        Destination URL(s):
        {urls.map((link, key) => renderLink(link, key))}
      </div>
    );
  }
  return null;
};

export const renderLink = (link, key) => (
  <div key={key} className="links-wrap">
    <strong>{link}</strong>
    <a
      href={link}
      className="eye-link"
      rel="noopener noreferrer"
      target="_blank"
    >
      <Icon size="large" className="canvas-link" name="eye" />
    </a>
  </div>
);

export const renderLeadFormName = (obj) => {
  if (obj.name) {
    return (
      <div>
        Lead Form Name: <strong>{obj.name}</strong>
      </div>
    );
  }
  return null;
};

export const renderPopupContent = (
  targetingsentencelines,
  urlTags,
  eventGroupName,
  productSetName,
  productCatalogName
) => (
  <div style={{ fontSize: '11.5px', textAlign: 'justify' }}>
    {targetingsentencelines.map((target) => (
      <div>
        <span>
          <strong>{target.content}</strong> {target.children[0]}
        </span>
        <br />
      </div>
    ))}
    {renderEventSourceName(eventGroupName)}
    {renderUrlTags(urlTags)}
    {renderProductCatalog(productSetName, productCatalogName)}
  </div>
);

export const renderUrlTags = (urlTags) => {
  const fontColor = urlTags !== '' && urlTags !== undefined ? 'black' : 'red';
  return (
    <div style={{ color: fontColor }}>
      <strong>UTM: </strong>
      <div>{urlTags}</div>
    </div>
  );
};

export const renderEventSourceName = (esgName) => {
  const showDiv = esgName === undefined || esgName === '' ? 'none' : 'block';

  return (
    <div style={{ display: showDiv }}>
      <p>
        <strong>Event Source Group Name: </strong>
        {esgName}
      </p>
    </div>
  );
};

export const renderProductCatalog = (productSetName, productCatalogName) => {
  return (
    <div>
      {productCatalogName ? (
        <div>
          <strong>Product Catalog: </strong> {productCatalogName}
        </div>
      ) : null}
      {productSetName ? (
        <div>
          <strong>Product Set: </strong> {productSetName}
        </div>
      ) : null}
    </div>
  );
};

export const sortAdsBy = (ads, criteria, campaignKey, adTypes) => {
  if (criteria === 'type') {
    // TO DO: dynamically determine the type of an ad
    const sortedAds = sortByTypeThenAdNameEnding(ads, campaignKey, adTypes);
    return sortedAds;
  }
  const adsByName = _.sortBy(ads, ['order', 'ad_name']);
  return adsByName;
};

export const getAdTypeOfAd = (currentAd, currentAdTypes, campaignKey) => {
  let currentAdType = '';

  if (currentAdTypes.length === 1) {
    currentAdType = currentAdTypes[0];
  } else if (currentAdTypes.length > 1) {
    const indexTracker = [];
    currentAdTypes.forEach((adType) => {
      const indexObj = {
        adType,
        index: currentAd.ad_name.toLowerCase().indexOf(adType.toLowerCase())
      };
      indexTracker.push(indexObj);
    });

    const maxObj = indexTracker.reduce((prev, current) => {
      return prev.index > current.index ? prev : current;
    });
    currentAdType = maxObj.adType;
  } else {
    currentAdType = '';
  }

  if (currentAdType === 'Video' && campaignKey !== 'VIDEO_VIEWS') {
    currentAdType = 'Cinemagraph';
  }

  if (
    (currentAdType === 'Video' || currentAdType === 'Cinemagraph') &&
    campaignKey === 'VIDEO_VIEWS'
  ) {
    currentAdType = 'OEM';
  }

  if (currentAdTypes.length <= 0) {
    currentAdType = 'Miscellaneous';
  }
  return currentAdType;
};

export const sortByTypeThenAdNameEnding = (ads, campaignKey, adTypes) => {
  const adsByTypeGroups = [];
  const miscTypeGroup = { type: 'Miscellaneous', ads: [] };
  const adsByTypeGroupsFromSecondDelimiter = [];

  adTypes.forEach((adType) => {
    const adGroup = {
      type: adType,
      ads: []
    };
    adsByTypeGroups.push(adGroup);
  });

  ads.forEach((ad) => {
    const adName = ad.ad_name;
    const currentAdTypes = adTypes.filter((adType) => {
      return adName.toLowerCase().includes(adType.toLowerCase());
    });
    const foundAdType = getAdTypeOfAd(ad, currentAdTypes, campaignKey);
    const adNameSplit = adName.split(foundAdType);
    const newAdNameEnding =
      adNameSplit.length > 1 ? adNameSplit[1].trim() : adNameSplit[0].trim();
    const typeGroupIndex = adsByTypeGroups.findIndex((group) => {
      return group.type === foundAdType;
    });
    if (typeGroupIndex === -1) {
      miscTypeGroup.ads.push({ adObj: ad, adNameEnding: adName });
    } else {
      const newObj = {
        adObj: ad,
        adNameEnding: newAdNameEnding
      };
      adsByTypeGroups[typeGroupIndex].ads.push(newObj);
    }
  });

  adsByTypeGroups.push(miscTypeGroup);

  adsByTypeGroups.map((group) =>
    adsByTypeGroupsFromSecondDelimiter.forEach((element) => {
      if (group.type === element.type) {
        group.ads.push({
          adObj: element.adObj,
          adNameEnding: element.adNameEnding
        });
      }
    })
  );

  const finalSortedAds = [];

  adsByTypeGroups.forEach((adGroup) => {
    const sortedAdsWithAdEndings = _.sortBy(adGroup.ads, [
      'order',
      'adNameEnding'
    ]);

    sortedAdsWithAdEndings.forEach((sortedAdWithAdEndings) => {
      const { adObj } = sortedAdWithAdEndings;
      finalSortedAds.push(adObj);
    });
  });
  return finalSortedAds;
};

export const checkAdProductSet = async (creativeId, token) => {
  const result = await getAdCreative(creativeId, token);
  const { product_set_id: productSetId } = result;
  return productSetId;
};

export const checkIfAdIsForInstagram = (adPreview) => {
  const { ad_original_name: originalAdName, ad_name: adName } = adPreview;
  const adNameInLowerCase = originalAdName
    ? originalAdName.toLowerCase()
    : adName.toLowerCase();
  const instagramTextIndex = adNameInLowerCase.indexOf('instagram stor');
  return instagramTextIndex !== -1;
};

export const getInstagramStoryByAdId = async (adId, token, callback) => {
  const getInstagramStoryResult = await getInstagramStoryIframe(adId, token);
  getInstagramStoryResult.originalAdId = adId;
  if (callback) callback(getInstagramStoryResult);
  return getInstagramStoryResult;
};

export const returnIframeForInstagramStory = (instagramData) => {
  const { data } = instagramData;
  if (data && data.length > 0) {
    const { body } = data[0];
    const iframe = body;
    return iframe;
  }
  return '<h3>There is no Instagram ad to be previewed.</h3>';
};



// WEBPACK FOOTER //
// ./src/utils/ad.common.js